import { useMutation } from '@tanstack/react-query'
import { saveAddon } from '../services/mapServices'

export function useAddonsUpdate() {
  const {
    mutate: addonsUpdate,
    isLoading: isLoadingAddonsUpdate,
    error,
    isSuccess,
  } = useMutation({
    mutationFn: saveAddon,
  })

  return {
    addonsUpdate,
    isLoadingAddonsUpdate,
    error,
    isSuccessAddonsUpdate: isSuccess,
  }
}
